import { Swiper, SwiperSlide } from 'swiper/react'
import { useState } from 'react'
import { useI18n } from 'builder/hooks/useI18n'

import Stockholm from '../../../assets/stockholm.png'
import London from '../../../assets/london.png'
import Sydney from '../../../assets/sydney.png'
import Dublin from '../../../assets/dublin.png'
import NewYork from '../../../assets/new_york.png'

import {
  Caption,
  Container,
  Slide,
  Image,
  CaptionHeader,
  CaptionSubHeader,
  SliderContainer,
  Overlay,
} from './styles'

const TRANSLATION = `builder.onboarding_ai_enhanced.slides`

const SliderAnimation = () => {
  const { i18n } = useI18n()
  const slides = [
    {
      header: i18n.t(`${TRANSLATION}.stockholm`),
      subHeader: i18n.t(`${TRANSLATION}.stockholm_used`),
      image: Stockholm,
    },
    {
      header: i18n.t(`${TRANSLATION}.dublin`),
      subHeader: i18n.t(`${TRANSLATION}.dublin_used`),
      image: Dublin,
    },
    {
      header: i18n.t(`${TRANSLATION}.london`),
      subHeader: i18n.t(`${TRANSLATION}.london_used`),
      image: London,
    },
    {
      header: i18n.t(`${TRANSLATION}.new_york`),
      subHeader: i18n.t(`${TRANSLATION}.new_york_used`),
      image: NewYork,
    },
    {
      header: i18n.t(`${TRANSLATION}.sydney`),
      subHeader: i18n.t(`${TRANSLATION}.sydney_used`),
      image: Sydney,
    },
  ]
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <Container>
      <Overlay position="left" />
      <Swiper
        loop={true}
        speed={800}
        autoplay={{ delay: 3000 }}
        initialSlide={2}
        slidesPerView={1.9}
        centeredSlides={true}
        onSlideChange={swiper => setActiveIndex(swiper.realIndex)}
      >
        {slides.map((s, index) => (
          <SwiperSlide key={index}>
            <Caption active={index === activeIndex}>
              <CaptionHeader>{s.header}</CaptionHeader>
              <CaptionSubHeader>{s.subHeader}</CaptionSubHeader>
            </Caption>
            <SliderContainer isNext={index === activeIndex + 1} active={index === activeIndex}>
              <Slide active={index === activeIndex}>
                <Image active={index === activeIndex} src={s.image} />
              </Slide>
            </SliderContainer>
          </SwiperSlide>
        ))}
      </Swiper>
      <Overlay position="right" />
    </Container>
  )
}

export default SliderAnimation
